import React, { useState } from "react";
import { Button, IconButton } from "@mui/material";
import Box from "../mui/Box";
import Typography from "../mui/Typography";
import FileUploader from "../common/FileUploader";
import ImageComponent from "../mui/Image";
import * as XLSX from "xlsx";
import { useImportCentreMutation } from "../../store/apis/centerApis"; // Import the mutation hook
import { showToast, toaster } from "../../helper/toaster";
import Loader from "../common/Loader";
import CentreTable from "../centres/CentreTable";
import {
  useDataInputImportMutation,
  useLazyTableHeaderDataByIdQuery,
  useSixerClassUploadMutation,
} from "../../store/apis/targetApis";
import DownloadToXlsxFile from "../../helper/DownloadToXlsxFile";
import TargetTable from "./TargetTable";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface ImportDialogContentProps {
  onClose: (
    event: React.MouseEvent | {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => void;
  onSuccess: () => void; // Prop to notify success in the parent
  location: any;
  formatedData: any;
  toggleImport: any;
  setIsDisabledImport: any;
  fileDownloadName?: string;
  isSixerClasTab?: boolean;
}
interface SheetHeader {
  keyName: string;
  label: string;
  sheetDataIndex: number;
  width?: number | string;
  editable?: boolean;
  toggleImport: any;
}
const ImportTargetContainer: React.FC<ImportDialogContentProps> = ({
  onClose,
  onSuccess,
  location,
  formatedData,
  toggleImport,
  setIsDisabledImport,
  fileDownloadName,
  isSixerClasTab,
}) => {
  const program = useSelector((state: RootState) => state.user.filter);
  const [sheetData, SetSheetData] = useState<any>([]);
  const [headers, setHeaders] = useState<any>([]);
  const [centerTableModal, setCenterTableModal] = useState<boolean>(false);
  const [readingFile, setReadingFile] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [isSavedButtonEnabled, setIsSavedButtonEnabled] = useState<any>({});
  const [errorMessages, setErrorMessages] = useState<Record<number, string>>(
    {}
  );

  const keyNameAsPerFile = ["region"];
  const handleFileChange = (value: { name: string; value: File[] | null }) => {
    if (value.value && value.value.length > 0) {
      setFile(value.value[0]);
    }
  };

  const handleFileUnselect = () => {
    setFile(null);
    SetSheetData([]);
    setHeaders([]);
  };

  const formatValue = (
    value: any,
    valueType: string | undefined
  ): string | number => {
    switch (valueType) {
      case "INTEGER":
        return parseInt(value, 10) || 0; // Ensure it's an integer
      case "NUMBER":
        return parseFloat(value) || 0; // Ensure it's a number
      case "STRING":
      default:
        return value ? value.toString() : ""; // Convert to string or fallback to an empty string
    }
  };

  const [
    getTableDataById,
    { data: targetHeader, isLoading: isLoadingTableHeaderData },
  ] = useLazyTableHeaderDataByIdQuery();

  const [sixerClassUpload, { isLoading: sixerClassUploading }] =
    useSixerClassUploadMutation();

  const [importCentre, { isLoading }] = useDataInputImportMutation();

  const getSheetHeader = () => {
    const parameterFields = location?.parameterFields;

    if (!Array.isArray(parameterFields)) {
      console.error("Parameter fields are not available or not an array.");
      return [];
    }

    // Combine static headers and dynamic headers
    const staticHeaders = [
      {
        keyName: "center",
        label: "Center",
        sheetDataIndex: 1,
        width: 180,
        editable: true,
        type: "STRING",
      },
      // {
      //   keyName: "region",
      //   label: "Region",
      //   sheetDataIndex: 2,
      //   width: 180,
      //   editable: true,
      // },
      // {
      //   keyName: "funderName",
      //   label: "Funder Name",
      //   sheetDataIndex: 3,
      //   width: 180,
      //   editable: true,
      // },
      // {
      //   keyName: "projectCode",
      //   label: "Project Code",
      //   sheetDataIndex: 4,
      //   width: 180,
      //   editable: true,
      // },
      // {
      //   keyName: "state",
      //   label: "State",
      //   sheetDataIndex: 5,
      //   width: 180,
      //   editable: true,
      // },
      // {
      //   keyName: "city",
      //   label: "City",
      //   sheetDataIndex: 6,
      //   width: 180,
      //   editable: true,
      // },
      // {
      //   keyName: "cityManagerName",
      //   label: "City Manager",
      //   sheetDataIndex: 7,
      //   width: 180,
      //   editable: true,
      // },
      // {
      //   keyName: "centerStatus",
      //   label: "Center Status",
      //   sheetDataIndex: 8,
      //   width: 180,
      //   editable: true,
      // },
    ];

    const dynamicHeaders = parameterFields.map((item: any, index: number) => ({
      keyName: item?.id || `field${index + 1}`, // Fallback if `item?.name` is undefined
      label: item?.name || `Field ${index + 1}`, // Fallback if `item?.name` is undefined
      sheetDataIndex: staticHeaders.length + index + 1, // Index adjusted after static headers
      width: 180,
      editable: true,
      type: item.valueType || "",
    }));

    return [...staticHeaders, ...dynamicHeaders];
  };

  function camelize(str: any) {
    if (!str) return;
    return str
      ?.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word: any, index: any) {
        return index === 0 ? word?.toLowerCase() : word?.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  const onDownloadTemplate = async () => {
    const res: any = await getTableDataById(location?.tabId);
    const dynamicHeader = res?.data?.headers?.map((item: any) => item?.name) || [];
    // console.log(dynamicHeader)
    // const dynamicHeader =
    //   res?.data?.headers?.map((item: any) =>
    //     isSixerClasTab ? camelize(item?.id) : item?.name
    //   ) || [];

    DownloadToXlsxFile({
      fileNamePrifix: fileDownloadName,
      sheetData: [dynamicHeader],
    });
  };

  // Removed unnecessary comments and optimized the handleImportFiles function
  // const handleImportFiles = () => {
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const data = new Uint8Array(e.target?.result as ArrayBuffer);
  //       const workbook = XLSX.read(data, { type: "array" });
  //       const firstSheetName = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[firstSheetName];

  //       const json = XLSX.utils.sheet_to_json(worksheet, {
  //         header: 1,
  //         defval: "",
  //       });

  //       const cleanedData = json.filter((row: any) =>
  //         row.some((cell: any) => cell !== "")
  //       );

  //       if (cleanedData.length > 0) {
  //         const excelHeaders = cleanedData[0] as string[]; // Headers from Excel file
  //         const headers = getSheetHeader(); // Predefined header configuration

  //         // Create a mapping from Excel headers to predefined headers
  //         const headerMap: any = {};
  //         excelHeaders?.forEach((excelHeader: any, index: number) => {
  //           const matchedHeader = headers?.find(
  //             (header: any) =>
  //               header.label.toLowerCase() === excelHeader.toLowerCase()
  //           );
  //           headerMap[index] = matchedHeader ? matchedHeader.keyName : null;
  //         });

  //         // Prepare the data rows
  //         const dataArray = cleanedData.slice(1).map((row: any, i: number) => {
  //           const rowObject: { [key: string]: any } = { id: i, errorMsg: "" };
  //           row.forEach((cell: any, index: number) => {
  //             const keyName = headerMap[index];
  //             rowObject[keyName || `unknown_${index}`] = keyName ? cell : "-";
  //           });
  //           return rowObject;
  //         });

  //         if (dataArray.length === 0) {
  //           showToast("Please Add Some Data In Excel File", "error");
  //           return;
  //         }

  //         setHeaders(headers);
  //         SetSheetData(dataArray);
  //         setCenterTableModal(true);
  //       }
  //     };
  //     reader.readAsArrayBuffer(file);
  //   }
  // };

  const detectAndConvertDateAndPercentage = (
    value: any,
    header: string
  ): any => {
    if (typeof value === "number") {
      // Check if the header contains "date" (case-insensitive)
      if (header?.toLowerCase().includes("date")) {
        // Handle Excel serial dates
        if (value > 59) {
          const excelBaseDate = new Date(1900, 0, 1); // January 1, 1900
          const offset = value > 59 ? 1 : 0; // Correct for Excel's leap year bug
          const jsDate = new Date(
            excelBaseDate.getTime() + (value - 1 - offset) * 24 * 60 * 60 * 1000
          );
          return jsDate.toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
        }
      }

      if (header?.toLowerCase().includes("float")) {
        // return `${value * 100}%`;
        return `${(value * 100).toFixed(0)}%`;
      }
    }

    return value;
  };

  const handleImportFiles = () => {
    console.log(file);
    if (file) {
      setReadingFile(true);
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        const json = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
        });

        const cleanedData = json.filter((row: any) =>
          row.some((cell: any) => cell !== "")
        );

        if (cleanedData.length > 0) {
          const excelHeaders = cleanedData[0] as string[]; // Headers from Excel file
          const headers = getSheetHeader(); // Predefined header configuration

          // Create a mapping from Excel headers to predefined headers
          const headerMap: any = {};
          excelHeaders?.forEach((excelHeader: any, index: number) => {
            const matchedHeader = headers?.find(
              (header: any) =>
                header.label.toLowerCase() === excelHeader.toLowerCase()
            );
            headerMap[index] = matchedHeader
              ? {
                  keyName: matchedHeader.keyName,
                  valueType: matchedHeader.type,
                }
              : null;
          });

          // Prepare the data rows
          const dataArray = cleanedData.slice(1).map((row: any, i: number) => {
            const rowObject: { [key: string]: any } = { id: i, errorMsg: "" };
            row.forEach((cell: any, index: number) => {
              const headerInfo = headerMap[index]; // Extract keyName and valueType
              const keyName = headerInfo?.keyName;
              const valueType = headerInfo?.valueType;

              // Convert the value based on the header type
              const convertedValue = detectAndConvertDateAndPercentage(
                cell,
                valueType || ""
              );
              rowObject[keyName || `unknown_${index}`] = keyName
                ? convertedValue
                : "-";
            });
            setReadingFile(false);
            return rowObject;
          });

          if (dataArray.length === 0) {
            showToast("Please Add Some Data In Excel File", "error");
            return;
          }

          setHeaders(headers);
          SetSheetData(dataArray);
          setCenterTableModal(true);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleDialogClose = () => {
    setCenterTableModal(false);
  };

  // Prepare data and submit it to the API
  const handleSubmit = async (tableData: any) => {
    // Check if any row is in "edit" mode
    const hasUnsavedChanges = Object.entries(isSavedButtonEnabled).some(
      ([rowId, modeObject]: any) => {
        if (modeObject.mode === "edit") {
          toaster.info("Changes detected! Don't forget to save.");
          return true;
        }
        return false;
      }
    );

    if (hasUnsavedChanges) {
      return;
    }

    try {
      const rows = sheetData.map((row: any) => {
        const dynamicRow: any = {};

        dynamicRow.center = row.center || "Unknown Center";

        location?.parameterFields.forEach((field: any) => {
          const key = field.id;
          const value = row[key] || "";
          dynamicRow[key] = formatValue(value, field.valueType);
        });

        return dynamicRow;
      });

      const payload = {
        targetAchievementTabId: location?.tabId,
        programMasterId: program?.selectedProgram?.value,
        programYearId: program?.selectedYear?.value,
        quarterMasterId: program?.selectedQuarter?.quarterMasterId,
        rows: rows,
      };

      // Call the importCentre mutation
      setUploading(true);
      const response = await importCentre(payload).unwrap();

      // Handle success (response)
      if (response.success) {
        setCenterTableModal(false);
        onSuccess();
        toggleImport();
        setIsDisabledImport(true);
      }
    } catch (err: any) {
      const newErrorMessages: any = {};

      // Check if err.data is a single string message
      if (typeof err.data === "string") {
        const match = err.data.match(/records\[(\d+)\]\.(\w+)/);

        if (match) {
          const [_, rowIndex, field] = match;
          newErrorMessages[+rowIndex] = `Error in ${field}: ${err.data}`;
        }
      }
      // Check if err.data is an array of messages
      else if (Array.isArray(err.data)) {
        err.data.forEach((error: string) => {
          const match = error.match(/records\[(\d+)\]\.(\w+)/);

          if (match) {
            const [_, rowIndex, field] = match;
            newErrorMessages[+rowIndex] = `Error in ${field}: ${error}`;
          }
        });
      }

      setErrorMessages(newErrorMessages);
      console.error("Error importing center:", err);
    } finally {
      setUploading(false);
    }
  };

  // handle for submit sixer class data
  const handleSubmitSixerClassData = async () => {
    if (!file) {
      console.error("No file selected");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("targetAchievementTabId", location?.tabId);
    formData.append("programMasterId", program?.selectedProgram?.value);
    formData.append(
      "quarterMasterId",
      program?.selectedQuarter?.quarterMasterId
    );
    formData.append("programYearId", program?.selectedYear?.value);

    try {
      const response = await sixerClassUpload(formData).unwrap();
      if (response?.success) {
        onSuccess();
        toggleImport();
        setIsDisabledImport(true);
        showToast(
          response?.message || "Sixer class updated successfully",
          "success"
        );
      }
    } catch (error) {
      console.error("Error uploading file", error);
    }
  };

  const handleEdit = (rowIndex: number, updatedRow: any) => {
    const updatedData = [...sheetData];
    updatedData[rowIndex] = updatedRow;
    SetSheetData(updatedData);
  };

  const handleDelete = (rowIndex: number) => {
    if (!sheetData?.some((row: any) => row?.id === rowIndex)) {
      return;
    }
    const updatedData = sheetData?.filter(
      (_: any, index: number) => index !== rowIndex
    );
    SetSheetData(updatedData);
  };

  return (
    <Box sx={{ padding: "24px", paddingTop: "12px" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginBottom: "18px" }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
          Import
        </Typography>
        <IconButton onClick={(e) => onClose(e, "escapeKeyDown")}>
          <ImageComponent
            sx={{ height: "24px", width: "24px" }}
            src="assets/images/login/crossIcon.svg"
            alt="Close Icon"
          />
        </IconButton>
      </Box>

      <FileUploader
        handleChange={handleFileChange}
        handleFileUnselect={handleFileUnselect}
        acceptedFileTypes={{
          "text/csv": [".csv"],
          "application/vnd.ms-excel": [".xls"],
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
            ".xlsx",
          ],
        }}
        multipleFiles={false}
        name="fileUpload"
        onDownloadTemplate={onDownloadTemplate}
      />

      <Box
        display="flex"
        justifyContent="space-between"
        sx={{ paddingTop: "28px", gap: "12px" }}
      >
        <Button
          onClick={(e) => onClose(e, "escapeKeyDown")}
          variant="outlined"
          color="secondary"
          sx={{
            width: "287px",
            backgroundColor: "#FFF",
            color: "#082648",
            border: "1px solid #082648",
            textTransform: "capitalize",
            borderRadius: "8px",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={
            readingFile
              ? undefined
              : isSixerClasTab
              ? handleSubmitSixerClassData
              : handleImportFiles
          }
          disabled={readingFile || sixerClassUploading}
          sx={{
            width: "287px",
            backgroundColor: "#FFF1B7",
            border: "1px solid #997906",
            color: "#082648",
            textTransform: "capitalize",
            borderRadius: "8px",
          }}
        >
          {readingFile || sixerClassUploading ? "Loading..." : "Import"}
        </Button>
      </Box>

      <TargetTable
        open={centerTableModal}
        onClose={handleDialogClose}
        headers={headers}
        sheetData={sheetData}
        onSubmit={handleSubmit}
        onEdit={handleEdit}
        onDelete={handleDelete}
        uploading={uploading}
        isSaveButtonEnabled={setIsSavedButtonEnabled}
        errorMessages={errorMessages}
        isLoading={isLoading}
        setSheetData={SetSheetData}
      />
    </Box>
  );
};

export default ImportTargetContainer;
